import React, {useContext, useState} from 'react';
import {useTranslation} from "react-i18next";

import InstallerContext from "@/context/InstallerContext";

import Step from "@/components/Step";
import StepTitle from "@/components/StepTitle";
import PrevButton from "@/components/PrevButton";
import NextButton from "@/components/NextButton";
import BackgroundCard from "@/components/BackgroundCard";
import ButtonWrapper from "@/components/ButtonWrapper";
import ErrorMessage from "@/components/ErrorMessage";
import StepDescription from "@/components/StepDescription";
import LoginProviderCard from "@/components/LoginProviderCard";
import WarningMessage from "@/components/WarningMessage";


const LoginProvider = ({nextStep, previousStep}) => {
  const {t} = useTranslation();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const {data, setLoginProvider} = useContext(InstallerContext)
  const {game, loginProvider, games} = data;
  
    const getLoginProvidersForGame = (gameId) => {
      const game = games.find(g => g.id === gameId);
      if (!game) {
        console.error("Game not found");
        return [];
      }
      
      return game.loginProviders.map(provider => ({
        id: provider,
        name: t(`login_providers.${provider}.name`),
        description: t(`login_providers.${provider}.description`),
      }));
    }
    
    const getLoginProvidersForMinecraft = () => {
      return [
        {
          id: "default",
          name: t('login_providers.minecraft_offline.name'),
          description: t('login_providers.minecraft_offline.description'),
        },
        {
          id: "minecraft",
          name: t('login_providers.minecraft.name'),
          description: t('login_providers.minecraft.description'),
        },
        {
          id: "xbox",
          name: t('login_providers.minecraft_xbox.name'),
          description: t('login_providers.minecraft_xbox.description'),
        }
      ];
    }
    
    const providers = game === 'minecraft' ? getLoginProvidersForMinecraft() : getLoginProvidersForGame(game);
  
  // If there is only one provider, select it automatically
  if (providers.length === 1 && loginProvider === null) {
    setLoginProvider(providers[0].id);
  }
  
  const handlePrevStep = (e) => {
    e.preventDefault();
    setLoginProvider(null);
    previousStep();
  }
  
  const handleNextStep = (e) => {
    e.preventDefault();
    setLoading(true);
    nextStep();
  };
  
  const disabled = loading || loginProvider === null;
  
  return (
      <Step>
        <StepTitle>
          {t('steps.4.title')}
        </StepTitle>
        <StepDescription>
          {t('steps.4.description')}
        </StepDescription>
        <StepDescription>
          {t('steps.4.selected_game')}: <span className="font-medium">{games.find(g => g.id === game).name}</span>
        </StepDescription>
        
        <ErrorMessage errors={errors}/>
        
        <WarningMessage message={t("auth_provider_warning")}/>
        
        <BackgroundCard>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8 md:mb-0">
            {providers.map(provider =>
                <LoginProviderCard key={provider.id} id={provider.id} name={provider.name} description={provider.description} selected={loginProvider === provider.id} />
            )}
          </div>
        </BackgroundCard>
        
        <ButtonWrapper>
          <PrevButton previousStep={handlePrevStep}/>
          <NextButton nextStep={handleNextStep} disabled={disabled} loading={loading}/>
        </ButtonWrapper>
      </Step>
  );
};

export default LoginProvider;